import Vue from 'vue';
import { updateField } from 'vuex-map-fields';
import types from '@/constants/types';

export default {
  updateField,
  [types.mutations.SAVE_USER](state, data) {
    Vue.set(state, 'rut', data.Rut);
    Vue.set(state, 'dv', data.Dv);
    Vue.set(state, 'token', data.token);
    Vue.set(state, 'user', data.user);
    Vue.set(state, 'names', data.names);
    Vue.set(state, 'surname', data.surname);
    Vue.set(state, 'secondSurname', data.secondSurname);
    Vue.set(state, 'idRefAddress', data.idRefAddress);
    Vue.set(state, 'idClient', data.clientId);
    Vue.set(state, 'isLogged', true);
  },
  [types.mutations.SAVE_TOKEN](state, data) {
    Vue.set(state, 'token', data.token);
  },
  [types.mutations.REMOVE_ALL](state) {
    Vue.set(state, 'token', '');
    Vue.set(state, 'Rut', '');
    Vue.set(state, 'Dv', '');
    Vue.set(state, 'user', '');
    Vue.set(state, 'isLogged', false);
    Vue.set(state, 'balance', '');
  },
};
